import React, { useRef, useState } from 'react';

import { Button } from '@rbilabs/universal-components';
import { usePaymentContext } from 'features/payment';
import { useIntl } from 'react-intl';

import { InlineModal } from 'components/ui';
import useErrorModal from 'hooks/use-error-modal';

import { AddPrepaidMethod, PrepaidMethodRef } from './add-prepaid-method';
import { ReloadMethodRef, ReloadPrepaidMethod } from './reload-prepaid-method';

export function AddReloadPrepaidMethodModal() {
  const {
    isAddReloadPrepaidMethodModalVisible,
    setIsAddReloadPrepaidMethodModalVisible,
    getPrepaidPaymentMethod,
  } = usePaymentContext();
  const prepaidMethodExists = !!getPrepaidPaymentMethod();
  const { formatMessage } = useIntl();
  const addPrepaidMethodRef = useRef<PrepaidMethodRef | null>(null);
  const reloadPrepaidMethodRef = useRef<ReloadMethodRef | null>(null);
  const [isLoading, setIsLoading] = useState(false);
  const [ErrorDialog, openErrorDialog] = useErrorModal({
    modalAppearanceEventMessage: 'Error: Vaulting Gift Card',
  });

  return (
    <InlineModal
      isOpen={isAddReloadPrepaidMethodModalVisible}
      webSize={{ width: '30%', height: 'auto', minWidth: 480 }}
      header={{
        title: !prepaidMethodExists
          ? formatMessage({ id: 'addGiftCard' })
          : formatMessage({ id: 'transferGiftCard' }),
        closeIconPosition: 'right',
        variant: 'light',
      }}
      footer={
        <Button
          isLoading={isLoading}
          isDisabled={isLoading}
          onPress={() => {
            if (prepaidMethodExists && reloadPrepaidMethodRef.current) {
              reloadPrepaidMethodRef.current.reloadCard();
            }
            if (!prepaidMethodExists && addPrepaidMethodRef.current) {
              addPrepaidMethodRef.current.addNewCard();
            }
          }}
          size="md"
          width="80%"
        >
          {formatMessage({ id: 'continue' })}
        </Button>
      }
      onClose={() => setIsAddReloadPrepaidMethodModalVisible(false)}
    >
      {prepaidMethodExists ? (
        <ReloadPrepaidMethod
          isLoading={isLoading}
          setIsLoading={setIsLoading}
          openErrorDialog={openErrorDialog}
          ref={reloadPrepaidMethodRef}
        />
      ) : (
        <AddPrepaidMethod
          isLoading={isLoading}
          setIsLoading={setIsLoading}
          openErrorDialog={openErrorDialog}
          ref={addPrepaidMethodRef}
        />
      )}

      <ErrorDialog />
    </InlineModal>
  );
}
